import {AbstractControl, type ValidationErrors} from '@angular/forms';

export function ResourceUrlValidator(control: AbstractControl): ValidationErrors | null {
  const urls: string[] = control.value;
  if (!urls || urls.length === 0) return null;

  const isLocal = location.hostname === 'localhost';
  const invalid = urls.filter(url => {
    const path = '/resource-explorer/view/';
    const host = location.origin.replace(/^https?:\/\//, '');
    const hasValidOrigin = isLocal
      ? url.startsWith('http://' + host + path) || url.startsWith('https://' + host + path) // nosonar - http only for local
      : url.startsWith(location.origin + path);
    return !hasValidOrigin || !/[0-9a-f-]{36}/.test(url.slice(-36));
  });

  return invalid.length > 0 ? {'resource-url': invalid} : null;
}
export function ResourceUrlValidatorMessage(): string {
  const isLocal = location.hostname === 'localhost';
  const scheme = isLocal ? 'http:// or https://' : 'https://'; // nosonar - http only for local
  return `The following are not valid ${scheme} resource URLs from this RDE instance's Resource Explorer.`;
}
